import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const defaultState = {
  invalid: null
}

const SignInReducer = combineReducers({
  oauthSignInRequest: createRequestReducer('SIGN_IN:OAUTH_LOGIN'),
  signInRequest: createReducer(
    { pending: false, error: null },
    {
      'SIGN_IN:EMAIL_AUTH_REQUEST': state => ({
        pending: true,
        error: null
      }),
      'SIGN_IN:EMAIL_AUTH_REQUEST_ERROR': (state, { error }) => ({
        pending: false,
        error: error
      }),
      'SIGN_IN:REFRESH': state => ({ ...defaultState })
    }
  )
})

export default SignInReducer
